import { AddressData } from '@service-victoria/component-library/ts/components/AddressLookup/interfaces';

import { radioOptions } from 'form/steps/shared';
import { TransactionSteps } from 'interfaces/transaction';

import { PostRegistrationRequest } from './types';

export const prepare = ({
  business,
  transactionId,
  worksite,
  review
}: TransactionSteps): PostRegistrationRequest => ({
  abn: business.ownerBuilder ? '' : business.abn,
  ownerBuilder: !!business.ownerBuilder,
  email: business.email,
  locationCode: business.locationShortCode.replace(/\s/g, ''),
  name: business.name,
  phoneNumber: business.phoneNumber,
  officeAddress: mapAddress(business.officeAddress),
  siteAddress: mapAddress(business.siteAddress),
  transactionId,
  businessName: business.businessName,
  permitNumber: business.permitNumber?.replace(/\//g, '') ?? undefined,
  roleTitle: review.roleTitle,
  practitionerLicense: business.practitionerLicense,
  siteType: radioOptions[worksite.siteType],
  buildingClass: business.buildingClass
});

const mapAddress = (address: AddressData) => ({
  addressId: address.fullDetails.id || '',
  postcode: address.fullDetails.postCode,
  fullAddress: address.fullDetails.fullAddress,
  state: address.fullDetails.state,
  suburb: address.fullDetails.suburb,
  lga: address.fullDetails.lga
});
